module.exports = __webpack_public_path__ + "img/portrait-055.8db3e0a9.jpg";